import React from 'react';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleDiagnosticAQuoiSattendre() {
  return (
    <BlogArticleLayout
      tag="Audit & Diagnostic"
      title="Diagnostic cybersécurité : à quoi s'attendre et comment ça marche"
      date="17 septembre 2026"
      ctaTitle="Essayez le diagnostic par vous-même"
      ctaText="Comptez environ 15 à 20 minutes pour obtenir votre premier score et un plan d'action personnalisé."
      ctaPrimaryLabel="Démarrer mon diagnostic gratuit"
    >
      <p style={s.intro}>
        Beaucoup de dirigeants repoussent leur premier audit cybersécurité parce qu'ils imaginent un exercice
        long, technique et intimidant. Un diagnostic automatisé comme celui d'Audit Cyber Pro fonctionne
        différemment. Voici, étape par étape, ce qui se passe réellement quand vous le lancez.
      </p>

      <h2 style={s.h2}>Étape 1 — La création de votre compte</h2>
      <p>
        Vous créez un compte en renseignant le nom de votre entreprise, votre email professionnel et un mot
        de passe. Aucune information technique n'est demandée à ce stade : l'inscription prend deux minutes.
      </p>

      <h2 style={s.h2}>Étape 2 — Le questionnaire, organisé par thématiques</h2>
      <p>
        L'audit se présente sous la forme d'une série de questions regroupées en modules — accès et
        identifiants, sauvegardes, postes de travail, sensibilisation des équipes, prestataires, conformité
        réglementaire. Vous répondez à votre rythme, avec vos connaissances actuelles : ce n'est pas un
        contrôle technique en direct sur vos systèmes, mais une évaluation basée sur vos réponses. Comptez
        quinze à vingt minutes pour un premier passage complet.
      </p>

      <h2 style={s.h2}>Étape 3 — Le score, immédiat et lisible</h2>
      <p>
        Une fois le questionnaire terminé, vous obtenez instantanément un score global en pourcentage, associé
        à un niveau : <strong>Critique</strong> (moins de 50 %), <strong>Vulnérable</strong> (entre 50 % et 80 %)
        ou <strong>Conforme</strong> (plus de 80 %). Ce score n'est pas une note abstraite : il reflète
        directement les écarts identifiés dans vos réponses.
      </p>

      <h2 style={s.h2}>Étape 4 — Le rapport et le plan d'action</h2>
      <p>
        Vous pouvez générer un rapport PDF complet qui synthétise les failles détectées et propose un plan
        d'action structuré sur quatre semaines, avec des actions concrètes semaine par semaine. Ce plan est
        généré automatiquement à partir de l'analyse de vos réponses : vous n'avez pas à interpréter vous-même
        des résultats bruts.
      </p>

      <h2 style={s.h2}>Étape 5 — Le suivi dans le temps</h2>
      <p>
        Le plan d'action alimente votre tableau de bord : chaque tâche peut être cochée au fur et à mesure de
        sa réalisation, et l'historique de vos audits reste consultable pour suivre votre progression. Selon
        votre forfait, un assistant IA reste également disponible pour répondre à vos questions de
        cybersécurité et de conformité au fil de votre démarche.
      </p>

      <h2 style={s.h2}>Ce que le diagnostic ne remplace pas</h2>
      <p>
        Un diagnostic automatisé donne une base fiable et rapide pour prioriser vos actions. Il ne remplace
        pas, en revanche, une validation juridique ou technique approfondie sur des points précis, ni un audit
        externe si votre situation l'exige (appel d'offres, exigence contractuelle d'un client). C'est
        un point de départ solide, pas un aboutissement.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleDiagnosticAQuoiSattendre;
